import React from "react";

const PasswordForget = () => {
  return <div>PasswordForget</div>;
};

export default PasswordForget;
